import Control from 'ol/control/Control'
import ol_ext_inherits from 'ol-ext/util/ext'


function addClass(elem, className) {
    var wholeWordRegexp = new RegExp("\\s*"+className+"\\s*","gi");
    var classes = elem.className.replace(wholeWordRegexp, " ") + " " + className;
    elem.className = classes;
}
function removeClass(elem, className) {
    var wholeWordRegexp = new RegExp("\\s*"+className+"\\s*","gi");
    elem.className = elem.className.replace(wholeWordRegexp, " ");
}
var lookupNodeLayer = {};
function addLookup(node,layer) {
    node.dataset.layername=layer.get("name");
    lookupNodeLayer[layer.get("name")]=layer;
}
function clearLookup() {
    lookupNodeLayer={};
}
function getLookup(node) {
    
    return lookupNodeLayer[node.dataset.layername]
}

function getRecursiveLayers(layersIn) {
    var layersOut = [];
    layersIn.forEach(layer => {
        if( layer.getLayers ) {
            layersOut = layersOut.concat(getRecursiveLayers(layer.getLayers()))
        }else {
            layersOut.push(layer);
        }
    })
    return layersOut;
}
 var BaseLayerSwitcher = function(options) {
    options = options || {};
    options.switcherClass = options.switcherClass || "ol-layerswitcher-image";
   

    this.createElements(options);

     this.drawPanelBind = this.drawPanel.bind(this);
     this.viewChangeBind = this.viewChange.bind(this);
    Control.call(this,
      {
        element: this.element,
        target: options.target
      });
     
    

  };
  ol_ext_inherits(BaseLayerSwitcher, Control);

  BaseLayerSwitcher.prototype.createElements = function(options) {
    this.element  = document.createElement('div');
    this.element.className = options.switcherClass;
    this.element.style.cssText="position:absolute;text-align:left;top:0px;right:0px;"
 
    this.panel_  = document.createElement('ul');
    this.panel_.className = "panel";
    this.panel_.style.cssText="height:auto;";
    this.element.appendChild(this.panel_);
    
  }
  /**
   * Set the map instance the control is associated with.
   * @param {ol.Map} map The map instance.
   */
  BaseLayerSwitcher.prototype.setMap = function(map) {
    Control.prototype.setMap.call(this, map);
    this.drawPanel();

    var map = this.getMap();
    if (map) {
      map.getLayerGroup().un('change', this.drawPanelBind);
      map.un('moveend', this.viewChangeBind);
    }

   
    // Get change (new layer added or removed)
    if (map) {
      //sobald sich irgendwas aendert wird das ausgefuehrt, viel zu oft
        //neue base layers werden on the fly eh nicht hinzugefuegt
      //map.getLayerGroup().on('change', this.drawPanelBind);
      map.on('moveend', this.viewChangeBind);
    }
  };
  /**
   * On view change hide layer depending on resolution / extent
   * @param {ol.event} map The map instance.
   * @private
   */
  BaseLayerSwitcher.prototype.viewChange = function(e) {
    var map = this.getMap();
    var res = map.getView().getResolution();
    var listElements = this.panel_.querySelectorAll("li");
    if(typeof(listElements) === "undefined" || !listElements) {
        return;
    }
    [].forEach.call(listElements, (li) => {
      //var layer = li.getUserData("layer");
        var layer = getLookup(li)
        if(layer) {
            if (layer.getMaxResolution() <= res || layer.getMinResolution() >= res) {
              addClass(li,"ol-layer-hidden")
            } else {
	      removeClass(li,"ol-layer-hidden")
            }
	    if (layer.getVisible()) {
		addClass(li,"select");
	    } else {
		    removeClass(li,"select");
	    }
        }
    });
      /*
    listElements.forEach(li => {
        //var layer = li.getUserData("layer");
        var layer = getLookup(li)
        if(layer) {
            if (layer.getMaxResolution() <= res || layer.getMinResolution() >= res) {
               removeClass(li,"ol-layer-hidden")
            } else {
                addClass(li,"ol-layer-hidden")
            }
        }
    })   
    */
  }
  /**
   *  Draw the panel control (prevent multiple draw due to layers manipulation on the map with a delay function)
   */
  BaseLayerSwitcher.prototype.drawPanel = function(e) {
    if (!this.getMap()) return;
   
    // Multiple event simultaneously / draw once => put drawing in the event queue
    this.dcount++;
    setTimeout(function() {
      this.drawPanel_();
    }.bind(this), 0);
  }

  /** Delayed draw panel control 
   * @private
   */
 BaseLayerSwitcher.prototype.drawPanel_ = function(e) {
    if (--this.dcount || this.dragging_) return;
     
    while (this.panel_.firstChild) {
        this.panel_.firstChild.remove();
    }
    this.drawList(this.panel_, getRecursiveLayers(this.getMap().getLayers()), this.getMap().getView().getCenter(), this.getMap().getView().getResolution());
  }

  /** Render a list of layer
   * @param {elt} element to render
   * @layers {Array{ol.layer}} list of layer to show
   * @api stable
   */
  BaseLayerSwitcher.prototype.drawList = function(ul, layers, center, resolution) {
    var self = this;

    var setVisibility = function(e) {
      e.preventDefault();
      var l = getLookup(this)
      self.switchLayerVisibility(l, layers);
    };
    var possibleVisibleBaseLayers = [];
    var isOneBaselayerVisible=false;

    clearLookup();
    layers.forEach(function(layer) {

      if (layer.get("baseLayer") === true) {
        
        var prev = layer.get("preview");
        if (!prev) {
          prev = layer.getPreview ? layer.getPreview(center, resolution) : ["none"];
        } else {
          prev = [prev];
        }
        var liElement  = document.createElement('li');
        liElement.className =  "ol-imgcontainer";
        addLookup(liElement,layer)
        //liElement.setUserData("layer",layer,null)
        liElement.ontouchstart = setVisibility;
        liElement.onclick = setVisibility;
	liElement.title = layer.get("htmltitle") || "";
	liElement.setAttribute("data-toggle","tooltip");
        
        if (layer.getVisible()) {
            addClass(liElement,"select");
        } 

        for (var k = 0; k < prev.length; k++) {
            var imgElement  = document.createElement('img');
            imgElement.src  = prev[k];
            liElement.appendChild(imgElement);
        }
          var pElement  = document.createElement('p');
          pElement.innerHTML = layer.get("title") || layer.get("name");
          liElement.appendChild(pElement);
          

        if (!self.testLayerVisibility(layer)) {
          layer.setVisible(false);
            addClass(liElement,"ol-layer-hidden");
          
        }else {          
          isOneBaselayerVisible=isOneBaselayerVisible || layer.getVisible() ;
          possibleVisibleBaseLayers.push(layer);
        }
          ul.appendChild(liElement);
        
      }
    });
    if(!isOneBaselayerVisible && possibleVisibleBaseLayers.length > 0) {
      possibleVisibleBaseLayers[0].setVisible(true);
    }
  };



  /** Change layer visibility according to the baselayer option
   * @param {ol.layer}
   * @param {Array{ol.layer}} related layers
   */
  BaseLayerSwitcher.prototype.switchLayerVisibility = function(l, layers) {
    if (!this.testLayerVisibility(l)) {
      return;
    }
    if (!l.get('baseLayer')) {
      l.setVisible(!l.getVisible());
    } else {
      if (!l.getVisible()) {
        l.setVisible(true);
      }
      
      layers.forEach(function(li) {
        if (l !== li && li.get('baseLayer') && li.getVisible()) {
          li.setVisible(false);
        }
      });
      
    }
    this.viewChange(null);
  }


  /** Check if layer is on the map (depending on zoom and extent)
   * @param {ol.layer}
   * @return {boolean}
   */
  BaseLayerSwitcher.prototype.testLayerVisibility = function(layer) {
    if (this.getMap()) {
      var res = this.getMap().getView().getResolution();
      if (layer.getMaxResolution() <= res || layer.getMinResolution() >= res) {
        return false;
      } else {
        return true;
      }
    }
    return true;
  };


  export default BaseLayerSwitcher;